import MedicalRecordSKUTable from './MedicalRecordSKUTable';

export default MedicalRecordSKUTable;
